import * as React from 'react';
import {
  type Type,
  withMeta,
  withSystem,
  Plugins,
  Atom,
} from '@packages/systems/wfdl';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {
  TBoolean,
  TNumber,
  TText,
  TList,
  TRecord,
  TUnion,
  TEnum,
  TTypeReference,
  TTypeApplication,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
import {
  TBoolean as TUnionBoolean,
  TRUE,
} from '@packages/systems/plugins-utils/Boolean';

const privilegedLabPlugin = Plugins.name('PrivilegedLab');

const render = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments.
    const defaultStyles = data.styles.reduce<Record<string, any>>(
      // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'style' implicitly has an 'any' type.
      (acc, style) => {
        acc[style.styleProperty] = style.value;
        return acc;
      },
      {}
    );

    return (
      <div {...generateAttributes(attributes, classes)} style={defaultStyles}>
        <ul>
          <li>
            TriStateBoolean:
            {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
            {data.triStateBooleanField}
          </li>
          {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
          <li>isCool: {data.isCool ? 'yes' : 'no'}</li>
          <li>
            isCoolest:{' '}
            {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
            {data.isCoolest && data.isCoolest.tag === 'True' ? 'dope' : 'nope'}
          </li>
          {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
          <li>bestSeason: {data.bestSeason}</li>
          <li>
            Superhero:
            <ul>
              {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
              <li>Alias: {data.person.alias}</li>
              {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
              <li>Age: {data.person.age}</li>
            </ul>
          </li>
          <li>
            Contact:
            <ul>
              <li>
                {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
                {data.contact.tag}: {data.contact.val}
              </li>
            </ul>
          </li>
          <li>
            List of anything has length:{' '}
            {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
            <strong>{(data.anyList && data.anyList.length) || 0}</strong>
          </li>
        </ul>
        <div style={{border: '4px solid white'}}>
          {/* @ts-expect-error - TS7006 - Parameter 'candidate' implicitly has an 'any' type. | TS7006 - Parameter 'idx' implicitly has an 'any' type. */}
          {data.candidates.map((candidate, idx) => (
            <div key={idx}>{candidate.alias}</div>
          ))}
        </div>
        <div style={{border: '4px solid green'}}>
          <div>
            <span>This is from a parameterized alias record field</span>
            <span
              data-automation-id="ParameterizedAliasRec"
              style={{fontSize: '24px'}}
            >
              {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
              {data.paramRec.param}
            </span>
          </div>
          <div>
            <span>This is from a parameterized alias</span>
            <span
              data-automation-id="ParameterizedAlias"
              style={{fontSize: '24px'}}
            >
              {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
              {data.param}
            </span>
          </div>
        </div>
        {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
        <span>{data.manylines}</span>
        {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
        <span>{data.url}</span>
        {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
        {data.favoriteColor ? (
          <div
            style={{
              padding: '20px',
              margin: '20px',
              backgroundColor: `rgb(${
                // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*
                data.favoriteColor.r
              }, ${
                // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*
                data.favoriteColor.g
              }, ${
                // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
                data.favoriteColor.b
              })`,
            }}
          >
            <span data-automation-id="KitchenSink-color-r">
              {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
              r: {data.favoriteColor.r}
            </span>
            <span data-automation-id="KitchenSink-color-g">
              {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
              g: {data.favoriteColor.g}
            </span>
            <span data-automation-id="KitchenSink-color-b">
              {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
              b: {data.favoriteColor.b}
            </span>
          </div>
        ) : null}
        {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
        <div>slider: {data.slider}</div>
        {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
        <div>interp: {data.interp}</div>
        <div>
          Current gps location:
          <span data-automation-id="KitchenSink-gps-lat">
            {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
            lat: {data.gps?.gpslatlong?.lat}
          </span>
          <span data-automation-id="KitchenSink-gps-long">
            {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
            long: {data.gps?.gpslatlong?.long}
          </span>
        </div>
        <div>
          {getChildren(data).map((child, idx) => (
            <div
              data-automation-id="inner-child"
              style={{display: 'flex', alignItems: 'center'}}
              key={idx}
            >
              <span>Child {idx + 1}: </span>
              {renderChild(child)}
            </div>
          ))}
        </div>
        {/* @ts-expect-error - TS18046 - 'data' is of type 'unknown'.*/}
        <span>{data.coolDistinct}</span>
      </div>
    );
  }
);

const heroType: Type = withMeta(
  {
    renderSummaryKeys: [
      {
        key: 'alias',
        addons: {
          prefix: '',
          postfix: ':',
        },
      },
      {
        key: 'age',
        addons: {
          prefix: ' ',
          postfix: '',
        },
      },
    ],
  },
  withSystem(
    {label: 'Superhero'},
    TRecord({
      alias: withMeta(
        {
          placeholder: 'Who is under the mask?',
        },
        withSystem(
          {
            label: 'Alias',
            defaultValue: 'Bruce Wayne',
            isBindable: true,
          },
          TText
        )
      ),
      age: withMeta(
        {
          value: {
            min: 0,
            max: 150,
            step: 1,
          },
        },
        withSystem(
          {
            label: 'Age',
            defaultValue: 33,
            isBindable: true,
          },
          TNumber
        )
      ),
    })
  )
);

export const KitchenSink = createIntegratedAtom({
  displayName: 'Kitchen Sink',
  render,
  icon: {
    type: 'Component',
    value: qualify(
      Plugins.name('PrivilegedLab'),
      iconName('KitchenSinkElement')
    ),
  },
  fields: {
    paramRec: withSystem(
      {
        label: 'Parameterized record field',
        isFullWidth: true,
      },
      TTypeApplication({
        con: TTypeConstructor(
          qualify(
            Plugins.name('PrivilegedLab'),
            typeName('ParameterizedRecordField')
          )
        ),
        arg: withSystem({isBindable: true}, TNumber),
      })
    ),
    param: withSystem(
      {isBindable: true, label: 'NumArg'},
      TTypeApplication({
        con: TTypeConstructor(
          qualify(Plugins.name('PrivilegedLab'), typeName('ParameterizedAlias'))
        ),
        arg: TNumber,
      })
    ),
    slider: withSystem(
      {label: 'My Slider', defaultValue: 1, isBindable: true},
      TTypeConstructor(qualify(Plugins.name('Basic'), typeName('Slider')))
    ),
    triStateBooleanField: withSystem(
      {label: 'TriStateBoolean', defaultValue: 'true', isBindable: true},
      TTypeConstructor(
        qualify(Plugins.name('Basic'), typeName('TriStateBoolean'))
      )
    ),
    url: withSystem(
      {label: 'My url'},
      TTypeConstructor(qualify(privilegedLabPlugin, typeName('URL')))
    ),
    gps: withSystem(
      {
        label: 'Best gps location',
        isFullWidth: true,
      },
      TTypeConstructor(qualify(privilegedLabPlugin, typeName('GPS')))
    ),
    favoriteColor: withSystem(
      {
        isBindable: true,
        label: 'My color',
        defaultValue: {r: 50, g: 50, b: 50},
      },
      TTypeConstructor(qualify(privilegedLabPlugin, typeName('Color')))
    ),
    manylines: withSystem(
      {label: 'Many lines'},
      TTypeConstructor(
        qualify(Plugins.name('Basic'), typeName('MultilineText'))
      )
    ),
    isCool: withSystem(
      {label: 'Is Cool', defaultValue: true, isBindable: true},
      TBoolean
    ),
    isCoolest: withMeta(
      {trueLabel: 'Dope', falseLabel: 'Nope'},
      withSystem(
        {label: 'Is Coolest', defaultValue: TRUE, isBindable: true},
        TUnionBoolean
      )
    ),
    bestSeason: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'Spring',
          isBindable: true,
          label: 'Best Season',
        },
        TEnum({
          Winter: 'Winter',
          Spring: 'Spring',
          Summer: 'Summer',
          Fall: 'Fall',
        })
      )
    ),
    person: heroType,
    contact: withSystem(
      {
        label: 'Contact',
        defaultValue: {tag: 'Mail'},
        isBindable: true,
      },
      TUnion({
        Mail: withMeta(
          {
            placeholder: '123 High Lane, Towsville',
          },
          withSystem(
            {
              label: 'Address',
              defaultValue: '1007 Mountain Drive, Gotham',
              isBindable: true,
            },
            TText
          )
        ),
        Phone: withMeta(
          {
            placeholder: '(555) 555 5555',
          },
          withSystem(
            {
              label: 'Number',
              defaultValue: '(111) 111 1111',
              isBindable: true,
            },
            TText
          )
        ),
      })
    ),
    // onClick: ({
    //   ...TEffect(TEmptyRecord),
    //   system: {isBindable: true},
    // }: TypeApplication),
    anyList: withSystem(
      {label: 'A list', isBindable: true},
      TList(TTypeReference('a'))
    ),
    colorList: withSystem(
      {label: 'Colors', isBindable: true},
      TList(TTypeConstructor(qualify(privilegedLabPlugin, typeName('Color'))))
    ),
    candidates: withSystem(
      {label: 'Candidates', defaultValue: [], isBindable: true},
      TList(heroType)
    ),
    styles: withMeta(
      {
        sortable: true,
      },
      withSystem(
        {
          label: 'Styles',
          isBindable: true,
          defaultValue: [
            {styleProperty: 'backgroundColor', value: 'red'},
            {styleProperty: 'padding', value: '20px'},
            {styleProperty: 'color', value: 'white'},
            {styleProperty: 'fontSize', value: '32px'},
            {styleProperty: 'lineHeight', value: '1.2'},
          ],
        },
        TList(
          withMeta(
            {
              renderSummaryKeys: [
                {
                  key: 'styleProperty',
                  addons: {
                    prefix: '',
                    postfix: '=',
                  },
                },
                {
                  key: 'value',
                  addons: {
                    prefix: '"',
                    postfix: '"',
                  },
                },
              ],
            },
            TRecord({
              styleProperty: withSystem(
                {
                  label: 'Property',
                },
                TText
              ),
              value: withSystem(
                {
                  label: 'Value',
                },
                TText
              ),
            })
          )
        )
      )
    ),
    // This can only be enabled once DataTypeSettings is gone
    // elementData: {
    //   type: 'Element',
    //   system: {label: 'element data'},
    // },
    children: withSystem(
      {
        label: 'Some elements',
        isBindable: true,
      },
      TTypeConstructor(qualify(privilegedLabPlugin, typeName('AddChildren')))
    ),
    coolDistinct: withSystem(
      {
        isBindable: true,
        label: 'Cool Distinct',
      },
      TTypeConstructor(qualify(privilegedLabPlugin, typeName('CoolDistinct')))
    ),
  },
  showEmpty: false,
});

// Test case for deeply nested list object
// listObjs: {
//   type: 'List',
//   meta: {
//     sortable: true,
//   },
//   of: withMeta(
//     {
//       layout: 'None',
//       renderSummaryKeys: [
//         {
//           key: 'a',
//           addons: {
//             prefix: '',
//             postfix: '',
//           },
//         },
//       ],
//     },
//     TRecord({
//       a: withSystem({
//         label: 'This is a text',
//       }, TText),
//       b: {
//         type: 'Number',
//         system: {
//           label: 'This is a number',
//         },
//         meta: {
//           value: {
//             min: 1,
//             max: 10,
//             step: 1,
//           },
//         },
//       },
//       c: withMeta(
//         {layout: 'None'},
//         TRecord({
//           nested: withSystem({
//             label: 'This is nested faaar',
//           }, TText),
//           thisEnum: withMeta(
//             {variant: 'menu'},
//             withSystem(
//               {label: 'Best Season'},
//               TEnum({
//                 Winter: 'Winter',
//                 Spring: 'Spring',
//                 Summer: 'Summer',
//                 Fall: 'Fall',
//               })
//             )
//           ),
//           listing: {
//             type: 'List',
//             system: {
//               label: 'wat',
//             },
//             of: withMeta(
//               {
//                 layout: 'None',
//                 renderSummaryKeys: [
//                   {
//                     key: 'a',
//                     addons: {
//                       prefix: '',
//                       postfix: '',
//                     },
//                   },
//                 ],
//               },
//               TRecord({
//                 a: withSystem({
//                   label: 'This is deep list text',
//                 }, TText),
//               },
//             },
//           },
//         })
//       ),
//     })
//   ),
//   system: {
//     label: 'Objs',
//     defaultValue: [
//       {
//         a: 'default text',
//         b: 7,
//         c: {
//           nested: 'i am deep',
//           thisEnum: 'Winter',
//           listing: [
//             {
//               a: 'give coke',
//             },
//             {
//               a: '?>',
//             },
//           ],
//         },
//       },
//       {
//         a: 'other',
//         b: 3,
//         c: {
//           nested: 'i am weird',
//           thisEnum: 'Winter',
//           listing: [
//             {
//               a: 'give cokesss',
//             },
//             {
//               a: '?asdffs>',
//             },
//           ],
//         },
//       },
//       {
//         a: 'what is it',
//         b: 2,
//         c: {
//           nested: 'hello',
//           thisEnum: 'Winter',
//           listing: [
//             {
//               a: 'give cokezzz',
//             },
//             {
//               a: 'zzzz?>',
//             },
//           ],
//         },
//       },
//     ],
//   },
// },
